export default __webpack_public_path__ + "bc3ac41b9b2bd69313d76e8692d1c6c9.png";